import React, { useState } from 'react'
import '../style/ProductDetails.css'


const ProductDetails = (props) => {

    const [isButtonActive, setButtonState] = useState(false);

    return (
        <div className="productDetails">
            <button className="productInfoBtn" onClick={()=> { setButtonState(!isButtonActive) }}> <span> { isButtonActive ? "Hide details" : "Show details" } </span> </button>
            <p className={isButtonActive ? "productDetailsTitle" : "productDetailsTitle hiddenElement"}>Track Details</p>
            <table className={isButtonActive ? "productDetailsTable" : "productDetailsTable hiddenElement"}>
                <tbody>
                    <tr className="tableRow">
                        <td className="tableCell">Initial Price</td>
                        <td className="tableCell">{props.item.initial_price}$</td>
                    </tr>
                    <tr className="tableRow orangeLine">
                        <td className="tableCell">Current Price</td>
                        <td className="tableCell">{props.item.current_price}$</td>
                    </tr>
                </tbody>
                <thead> 
                    <tr className="tableRow">
                        <th className="tableCell">You saving</th>
                        <th className="tableCell">{props.item.initial_price - props.item.current_price}$</th>
                    </tr>
                </thead>

            </table>
        </div>

    )
}

/*



*/





export default ProductDetails